import type { PreviewMode } from 'services/Store/Project/enums'

import type { TestMultipleChoiceElementType } from '../testMultipleChoiceTypes'
import TestMultipleChoiceElementEditor from './TestMultipleChoiceElementEditor'
import TestMultipleChoiceElementPreview from './TestMultipleChoiceElementPreview'

const COMPONENTS_MAP: Partial<Record<PreviewMode, TestMultipleChoiceElementType>> = {
  editor: TestMultipleChoiceElementEditor,
}

const TestMultipleChoiceElement: TestMultipleChoiceElementType = ({ mode, ...rest }) => {
  const Component = COMPONENTS_MAP[mode.previewMode] || TestMultipleChoiceElementPreview
  return <Component mode={mode} {...rest} />
}

export default TestMultipleChoiceElement
